import LazyLoad from "vanilla-lazyload";
import Swiper from "swiper";

export default function EditionsSlider(container) {
  const sliderContainer = container;

  const sliderContentList = document.querySelectorAll(".js-editions-content");
  const nextButtonElement = document.querySelector(".js-editions-slider-next");
  const previousButtonElement = document.querySelector(
    ".js-editions-slider-prev"
  );
  // let mobileStretch = 20;

  let slider;
  const sliderOptions = {
    init: false,
    loop: true,
    centeredSlides: true,
    effect: "coverflow",
    grabCursor: true,
    spaceBetween: 0,
    slidesOffsetBefore: 0,
    speed: 500,
    slidesPerView: "auto",
    coverflowEffect: {
      rotate: 0,
      slideShadows: false,
      depth: 400,
      stretch: 49,
      modifier: 1
    },
    breakpoints: {
      1200: {
        coverflowEffect: {
          rotate: 0,
          slideShadows: false,
          depth: 266,
          stretch: 159,
          modifier: 1
        }
      }
    },
    slideClass: "js-editions-slide",
    wrapperClass: "js-editions-slider-wrapper",
    navigation: {
      nextEl: nextButtonElement,
      prevEl: previousButtonElement
    },
    on: {
      init() {
        // console.log("swiper initialized");
        setTimeout(() => {
          initLazyLoad();
        }, 200);
      }
    }
  };

  initSlider();

  slider.on("slideChange", function changeCurrentSlide() {
    const index = slider.realIndex;

    const currentSlide = slider.slides[index];

    const activeId = currentSlide.getAttribute("id");

    for (let i = 0, len = sliderContentList.length; i < len; i++) {
      const sliderContent = sliderContentList[i];
      const sliderContentDataId = sliderContent.getAttribute("data-id");

      if (sliderContentDataId === activeId) {
        if (!sliderContent.classList.contains("is-show")) {
          sliderContent.classList.add("is-show");
        }
      } else if (sliderContent.classList.contains("is-show")) {
        sliderContent.classList.remove("is-show");
      }
    }
  });

  function initLazyLoad() {
    const lazyLoad1 = new LazyLoad({
      container,
      elements_selector: ".js-lazy"
    });

    const lazyLoad2 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-bg",
      to_webp: true
    });

    const lazyLoad3 = new LazyLoad({
      container,
      elements_selector: ".js-lazy-webp",
      to_webp: true
    });

    lazyLoad1.loadAll();
    lazyLoad2.loadAll();
    lazyLoad3.loadAll();
  }

  function initSlider() {
    slider = new Swiper(sliderContainer, sliderOptions);
    slider.init();
  }
}
